<template>
  <div>
    <v-form ref="form" v-model="valid">
      <v-row justify="center" class="pt-8" no-gutters>
        <v-col xl="8" lg="11" md="11" sm="11" cols="12">
          <v-row justify="center" class="mx-0">
            <slot name="user"></slot>

            <v-col cols="12" v-if="isAuthenticated">
              <v-text-field class="mt-n4" v-model="address.name"
                label="Nombre dirección"
                hint="Requerido"
                :rules="[isRequired]"
                persistent-hint
                solo
                dese>
              </v-text-field>
            </v-col>

            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-select class="mt-n4" v-model="address.region"
                :items="departments"
                item-value="code"
                item-text="name"
                label="Departamento"
                hint="Requerido"
                :rules="[isRequired]"
                :loading="loadingDepartments"
                @change="changeDepartament"
                persistent-hint
                solo
                dese
                return-object>
              </v-select>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-select class="mt-n4" v-model="address.city"
                :items="cities"
                item-text="name"
                item-value="code"
                label="Ciudad"
                hint="Requerido"
                :rules="[isRequired]"
                :disabled="!cities || !cities.length"
                :loading="loadingCities"
                persistent-hint
                solo
                dese
                return-object>
              </v-select>
            </v-col>
            <v-col cols="12">
              <v-text-field class="mt-n4" v-model="address.address"
                label="Descripción"
                hint="Requerido"
                :rules="[isRequired, minimum(10)]"
                persistent-hint
                solo
                dese>
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-text-field class="mt-n4" v-model="address.neighborhood"
                label="Barrio"
                hint="Requerido"
                :rules="[isRequired]"
                persistent-hint
                solo
                dese>
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-text-field class="mt-n4" v-model="address.additional_address"
                label="Datos adicionales"
                hint="Opcional"
                persistent-hint
                solo
                dese>
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-text-field class="mt-n4" v-model="address.cell_phone"
                label="Celular"
                hint="Requerido"
                :rules="[isRequired, isNumeric, minimum(10)]"
                persistent-hint
                solo
                dese>
              </v-text-field>
            </v-col>
            <v-col xl="6" lg="6" md="6" sm="6" cols="12">
              <v-text-field class="mt-n4" v-model="address.landline_phone"
                label="Telefono fijo"
                hint="Opcional"
                :rules="[isNumeric]"
                persistent-hint
                solo
                dese>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row justify="end" class="mt-n3 pb-6 mx-0">
            <v-col xl="4" lg="4" md="4" sm="6" cols="6" v-if="showCancel">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" outlined dark @click="cancel">
                Cancelar
              </v-btn>
            </v-col>
            <v-col :xl="buttonLength" :lg="buttonLength" :md="buttonLength" :sm="buttonLengthMobile"  :cols="buttonLengthMobile">
              <v-btn class="text-none" block height="48" color="blue darken-1" elevation="0" :loading="loading" :disabled="!valid" :dark="valid" @click="save">
                {{ action }}
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import navigationMixin from '@/mixins/navigation'
import { isRequired, isNumeric, minimum } from '@/shared/validations'

export default {
  name: 'AddressForm',
  mixins: [navigationMixin],
  props: {
    address: {
      type: Object,
      default: function () {
        return {
          name: '',
          region: '',
          city: '',
          address: '',
          neighborhood: '',
          additional_address: '',
          cell_phone: '',
          landline_phone: ''
        }
      }
    },
    action: {
      type: String,
      default: 'Crear'
    },
    supportLocalSave: {
      type: Boolean,
      default: false
    },
    showCancel: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isRequired,
      isNumeric,
      minimum,
      valid: true,
      loadingDepartments: true,
      loadingCities: false
    }
  },
  computed: {
    ...mapState('shared', ['error', 'loading']),
    ...mapState('shipping', ['departments', 'cities']),
    ...mapState('auth', ['isAuthenticated']),
    buttonLength () {
      return this.showCancel ? 4 : 6
    },
    buttonLengthMobile () {
      return this.showCancel ? 6 : 12
    }
  },
  methods: {
    ...mapActions('shipping', ['getDepartments', 'getCities']),
    ...mapActions('address', ['createAddress', 'updateAddress']),
    async changeDepartament (departament, clear = true) {
      if (!departament) {
        return
      }

      if (clear) {
        this.address.city = null
      }

      if (departament && departament.code) {
        this.loadingCities = true
        await this.getCities(departament.code)
        this.loadingCities = false
      }
    },
    async save () {
      if (!this.$refs.form.validate()) {
        return
      }

      if (this.supportLocalSave) {
        this.$emit('save', this.address)
        return
      }

      const address = await this.saveAddress(this.address)
      this.$emit('save', address)
    },
    saveAddress (address) {
      if (!address.address_id) {
        return this.createAddress(address)
      }

      return this.updateAddress(address)
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  async mounted () {
    this.loadingDepartments = true
    await this.getDepartments()
    this.loadingDepartments = false
    this.changeDepartament(this.address.region, false)
  }
}
</script>
